import { render, staticRenderFns } from "./CreateTicket.vue?vue&type=template&id=560ad0f6&scoped=true&"
import script from "./CreateTicket.vue?vue&type=script&lang=js&"
export * from "./CreateTicket.vue?vue&type=script&lang=js&"
import style0 from "./CreateTicket.vue?vue&type=style&index=0&id=560ad0f6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560ad0f6",
  null
  
)

export default component.exports